import { useUpdateEffect } from '@xing-com/crate-entity-pages-common';
import { useErrorContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-error-context';
import { IconHide } from '@xing-com/icons';

import { useDisableArticleMutation } from '../../../../hooks/use-disable-article-mutation';
import * as Styled from '../article-card-top.styles';

import type { ArticleControlButton } from './types';

export const ArticleHideButton: React.FC<ArticleControlButton> = ({
  article,
  disabled,
  onLoadingChange,
}) => {
  const { showError } = useErrorContext();

  const [handleDisableArticle, { loading }] = useDisableArticleMutation();

  useUpdateEffect(() => {
    onLoadingChange(loading);
  }, [loading]);

  const handleClick = async () => {
    try {
      await handleDisableArticle(article);
    } catch (error) {
      showError({ message: error.message, error });
    }
  };

  return (
    <Styled.Button
      data-testid={`ARTICLE-HIDE-BUTTON-${article.id}`}
      icon={IconHide}
      size="small"
      variant="tertiary"
      disabled={disabled}
      loading={loading}
      onClick={handleClick}
    />
  );
};
